import { createVNode as d, mergeProps as l } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/SendMailFilledStandard.js";
import n from "../components/PfIcon.js";
const r = (e, t) => {
  const a = {
    ...e,
    ...t.attrs
  };
  return d(n, l(a, {
    icon: i
  }), null);
};
r.displayName = "SendMailFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
